import styled, { css } from 'styled-components'
import { Button } from 'components/button/styles'
import { H1, Subheading } from '../typography/styles'

/**
 * Will add "px" if value is a number
 * @param {any} input Value to assign to CSS property
 */
const format = (input) => (typeof input === 'number' ? `${input}px` : input)

const Card = styled.div`
	background-color: #ffffff;
	margin: 10px auto 0 auto;
	width: 100%;
	border-radius: 5px;
	padding: 4px;
	display: flex;
	box-shadow: 1px 17px 30px rgba(194, 195, 199, 0.15);
	flex-direction: column;
	flex: auto;

	@media screen and (max-width: 600px) {
		padding: 25px;
	}
`

const CardHeading = styled(H1)`
	margin-bottom: 12px;
`

const CardSubheading = styled(Subheading)`
	/* margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '36px')}; */
`

const FlexComponent = styled.div`
	${({ justifyContent }) =>
		justifyContent &&
		css`
			justify-content: ${justifyContent};
		`}

	${({ marginTop }) =>
		marginTop &&
		css`
			margin-top: ${format(marginTop)};
		`}

  ${({ alignItems }) =>
		alignItems &&
		css`
			align-items: ${alignItems};
		`}

  ${({ padding }) =>
		padding &&
		css`
			padding: ${padding};
		`}

  ${({ paddingBottom }) =>
		paddingBottom &&
		css`
			padding-bottom: ${format(paddingBottom)};
		`}

  ${({ paddingTop }) =>
		paddingTop &&
		css`
			padding-top: ${format(paddingTop)};
		`}

  ${({ paddingLeft }) =>
		paddingLeft &&
		css`
			padding-left: ${format(paddingLeft)};
		`}

  ${({ paddingRight }) =>
		paddingRight &&
		css`
			padding-right: ${format(paddingRight)};
		`}

  flex-wrap: ${(props) => props.flexWrap || 'wrap'};

	${({ xs, sm, md, lg, xl, fillRow }) => {
		const small = sm || xs
		const medium = md || sm || xs
		const large = lg || md || sm || xs
		const xlarge = xl || lg || md || sm || xs

		return (
			(xs || small || medium || large || xlarge) &&
			css`
				/** extra small */
				@media (min-width: 0px) {
					flex: ${xs};
					flex-basis: ${`${(xs / 12) * 100}%`};

					${!fillRow &&
					css`
						max-width: ${`${(xs / 12) * 100}%`};
					`}
				}

				/** small */
				@media (min-width: 576px) {
					flex: ${small};
					flex-basis: ${`${(small / 12) * 100}%`};

					${!fillRow &&
					css`
						max-width: ${`${(small / 12) * 100}%`};
					`}
				}

				/** medium (typical min is 768px) */
				@media (min-width: 800px) {
					flex: ${medium};
					flex-basis: ${`${(medium / 12) * 100}%`};
					${!fillRow &&
					css`
						max-width: ${`${(medium / 12) * 100}%`};
					`}
				}

				@media (min-width: 992px) {
					flex: ${large};
					flex-basis: ${`${(large / 12) * 100}%`};
					${!fillRow &&
					css`
						max-width: ${`${(large / 12) * 100}%`};
					`}
				}

				@media (min-width: 1200px) {
					flex: ${xlarge};
					flex-basis: ${`${(xlarge / 12) * 100}%`};
					${!fillRow &&
					css`
						max-width: ${`${(xlarge / 12) * 100}%`};
					`}
				}
			`
		)
	}}
`

const Row = styled(FlexComponent)`
	display: flex;
	flex-direction: row;
	width: ${({ width }) => width || '100%'};
`

const Col = styled(FlexComponent)`
	display: flex;
	flex-direction: column;
`
const FiltersRow = styled(Row)`
	${Col} {
		padding: 0px 4px;
	}

	${Button} {
		margin: 10px auto;
	}
`
export { Card, CardHeading, CardSubheading, Row, Col, FiltersRow }
